import React from 'react';
import { InventoryItem } from '../types/interfaces';

interface ProcessingProps {
  inventory?: InventoryItem[];
  refreshInventory?: () => Promise<void>;
}

/**
 * Retired. The old Processing page proofed down with a flat 0.98 "shrinkage"
 * factor and posted to /api/package, which no longer exists. Spirits bottling
 * (proofing down, water by 27 CFR 30.64 with the TTB Gauging Manual tables,
 * dump/batch sheets) lives in Spirits → Bottle.
 */
const Processing: React.FC<ProcessingProps> = () => (
  <div className="page-container" data-testid="processing-retired">
    <h2 className="app-header">Processing</h2>
    <p>
      This page has been retired. Use <strong>Spirits → Bottle</strong> to proof down and bottle spirits; water is
      calculated with the official TTB Gauging Manual tables (27 CFR 30.64).
    </p>
  </div>
);

export default Processing;
